import React from 'react';
import { headerItemPropTypes } from './HeaderItemPropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './HeaderItem.module.scss';
const HeaderItem = ({
  breakpoint,
  href,
  label,
  title,
  badge,
  expandAndFocusSearchBar,
  iconName,
  classname
}) => {
  if (!breakpoint.desktop && !breakpoint.mobile || !href && !title && !label && !expandAndFocusSearchBar && !iconName) {
    return null;
  }
  const Component = href ? 'a' : 'div';
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, expandAndFocusSearchBar && {
    onClick: expandAndFocusSearchBar
  }, {
    href: href,
    title: title,
    className: `
    ${styles.root}
    ${typeof breakpoint !== 'undefined' && !(breakpoint !== null && breakpoint !== void 0 && breakpoint.desktop) ? styles.rootHiddenDesktop : ''}
    ${typeof breakpoint !== 'undefined' && !(breakpoint !== null && breakpoint !== void 0 && breakpoint.mobile) ? styles.rootHiddenMobile : ''}
    ${styles[`root${iconName}`]}
    ${classname || ''}`
  }), (iconName || badge) && /*#__PURE__*/React.createElement("div", {
    className: styles.rootIconWrapper
  }, iconName && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    size: {
      width: 20,
      height: 20
    },
    classname: styles.rootIcon
  }), badge && /*#__PURE__*/React.createElement("span", {
    className: styles.rootBadge
  }, badge)), label && /*#__PURE__*/React.createElement("span", {
    className: styles.rootLabel
  }, label));
};
export default HeaderItem;